@if (visible) {
  <div style="width: 99%; height: 99%; position: absolute; display: flex; justify-content: center; align-items: center">
    <div style="width: 100%; height: 100%; z-index: 10000; position: fixed; top: 0; left: 0; opacity: 0.8; background-color: white;">
    </div>
    <div style="z-index: 10001; position: fixed; background-color: white; opacity: 0.9; border: 1px solid #aaa; margin: 15px; padding: 28px; display:flex; justify-content: center;flex-flow:column;align-items: center;">
      <mat-spinner style="margin-bottom:15px"></mat-spinner>
      <div style="min-width:140px; text-align:center">{{pleaseWaitText}}</div>
    </div>
  </div>
}
